import { useContext } from 'react';
import { UserStateContext } from 'context/user-state-context';
import { isDataFieldsRedesignOn, readRedesignOverride } from './data-fields-redesign';

/**
 * Whether the Data Fields redesign is on for the person looking, and whether that's known yet.
 *
 * `isLoading` is true while flags load, including after a "Working as" switch, when the previous
 * company's flags are still in context. Treat it as "not decided yet" rather than on or off, or
 * the wrong UI flashes. `isEffectivelySuperuser` is the context's own predicate, so a superuser
 * viewing as a customer sees what the customer sees.
 *
 * `urlOverride` lets the /data-fields route apply ?redesign=on|off in the same render that reads
 * it, before it has been remembered in this browser.
 */
export function useDataFieldsRedesign({
  urlOverride = null
} = {}) {
  const {
    flags,
    isEffectivelySuperuser,
    isLoadingFlags
  } = useContext(UserStateContext);
  return {
    isOn: isDataFieldsRedesignOn({
      flags,
      isSuperuser: !!isEffectivelySuperuser,
      override: urlOverride || readRedesignOverride()
    }),
    isLoading: !!isLoadingFlags
  };
}